import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Bell } from "lucide-react";
import { api } from "@/lib/api";

export const NotificationsBell = () => {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const nav = useNavigate();
  const load = () => api.get("/notifications").then((r) => setItems(r.data)).catch(() => {});
  useEffect(() => { load(); const t = setInterval(load, 60000); return () => clearInterval(t); }, []);
  const unread = items.filter((n) => !n.read).length;
  const toggle = () => {
    setOpen(!open);
    if (!open && unread) { api.post("/notifications/read").then(load); }
  };
  return (
    <div className="relative">
      <button onClick={toggle} data-testid="nav-notifications" aria-label="Notifiche" className="relative p-2 rounded-full border border-[#0D2B5A]/20 hover:bg-[#0D2B5A]/5 transition-colors">
        <Bell className="w-4 h-4"/>
        {unread > 0 && <span data-testid="nav-notifications-count" className="absolute -top-1 -right-1 min-w-[18px] h-[18px] px-1 rounded-full bg-gold text-[#0D2B5A] text-[10px] font-bold flex items-center justify-center">{unread}</span>}
      </button>
      {open && (
        <div className="absolute right-0 mt-2 w-80 max-h-96 overflow-y-auto bg-white rounded-2xl border border-slate-200 shadow-xl z-50 text-left" data-testid="notifications-panel">
          <div className="px-4 py-3 border-b border-slate-100 font-display font-bold text-aic-navy">Notifiche</div>
          {items.length === 0 && <p className="px-4 py-6 text-sm text-slate-500">Nessuna notifica.</p>}
          {items.map((n) => (
            <button key={n.id} onClick={() => { setOpen(false); nav(n.link || "/dashboard"); }} className={`w-full text-left px-4 py-3 border-b border-slate-50 hover:bg-gold/10 ${n.read ? "" : "bg-gold/5"}`}>
              <div className="text-sm font-semibold text-aic-navy">{n.title}</div>
              <div className="text-xs text-slate-600 mt-0.5">{n.body}</div>
              <div className="text-[10px] text-slate-400 mt-1">{new Date(n.createdAt).toLocaleString("it-IT")}</div>
            </button>
          ))}
          <Link to="/pacchetti" onClick={() => setOpen(false)} className="block px-4 py-2.5 text-xs font-semibold text-center text-aic-navy hover:text-[#C98A3C]">Vai ai pacchetti</Link>
        </div>
      )}
    </div>
  );
};
